import React from "react";
import { useLocation } from "react-router-dom";
import AudienceBuilderV2 from "../../components/builder-v2/AudienceBuilderV2";

function BuilderV2() {
	const location = useLocation();
	const initialData = location.state?.aiAudienceData || null;
	const fromGenerationId = location.state?.generationId || null;
	const createSiloId = location.state?.generationSiloId || null;
	return (
		<AudienceBuilderV2
			mode="create"
			initialData={initialData}
			fromGenerationId={fromGenerationId}
			createSiloId={createSiloId}
		/>
	);
}

export default BuilderV2;
